const miembroMacro = 'macrosweb.tr4iner.com';
const miembroMacroTest = 'macroswebtest.tr4iner.com';
const miembroAsesoria = 'miembro.tr4iner.com';
const miembroAsesoriaTest = 'miembrotest.tr4iner.com';
const hostname = window.location.hostname;

export const baseUrlMacrosProd = 'https://apimacros.tr4iner.com/v1.0.9/';
export const baseUrlAsesoriaProd = 'https://apiasesoria.tr4iner.com/v1.0.15/';
export const baseUrlDev = 'https://localhost:5001/';

export const usuarioApiURL = () => {
  if (hostname === miembroMacro || hostname === miembroMacroTest) {
    return baseUrlMacrosProd;
  } else if (hostname === miembroAsesoria || hostname === miembroAsesoriaTest) {
    return baseUrlAsesoriaProd;
  }
  return baseUrlAsesoriaProd;
};
